import { Link } from 'react-router-dom'
import Layout from '../../components/layout/Layout'

const ThoughtMobileMocks = () => {
  return (
    <Layout>
      <div className="w-full max-w-4xl px-4 md:px-8 lg:px-12 py-12 space-y-6">
        <h1 className="text-[2.488rem] font-semibold text-foreground font-sans tracking-[-0.025em] leading-[1.2] [text-wrap:balance]">
          Mobile Interface Mockups and Design Systems
        </h1>
        
        <p className="text-foreground text-[1.375rem] leading-[1.3] [text-wrap:balance]">
          A deep dive into mobile interface design patterns and component organization strategies.
        </p>

        <div className="subline text-muted-foreground text-[0.875rem] leading-[1.2]">
          By{' '}
          <Link to="#" className="text-foreground no-underline hover:underline">
            Jean Mazouni
          </Link>{' '}
          in{' '}
          <Link to="#" className="text-foreground no-underline hover:underline">
            Design Systems
          </Link>{' '}
          on December 15, 2024
        </div>

        <div className="space-y-8">
          <div className="grid grid-cols-1 md:grid-cols-6 gap-8 items-start">
            <div className="col-span-2">
              <img
                src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Untitled-2024-11-02-1609-p8aRMwBmjWxg3L5K3vr1xByeZ2ePlm.png"
                alt="AI Agents interface showing various agents like Finance checker and File Exporter with status indicators"
                className="w-full h-auto"
              />
            </div>
            <div className="col-span-4">
              <p className="text-foreground text-lg leading-relaxed">
                Drafting concepts for mobile UX/UI design is the best way to experiment because it provides a low-cost, low-commitment approach to exploring a variety of ideas. Early-stage sketches or wireframes allow designers to quickly visualize concepts, test usability, and identify potential flaws before significant resources are invested. This rapid experimentation encourages creativity, as designers can freely explore different layouts, interactions, and design elements without the fear of failure. By focusing on the overall user experience rather than perfecting details, drafting enables a more iterative approach to identifying what works and what doesn't.
              </p>
            </div>
          </div>
          <div className="w-full">
            <p className="text-foreground text-lg leading-relaxed">
              Iterating on these drafts helps refine good ideas and discard weak ones based on user feedback and usability testing. Early concepts can reveal insights about user behavior, technical constraints, and design inconsistencies that might not be evident without a tangible representation. Iteration ensures that each version of the design builds on previous learnings, leading to a polished product that is both functional and user-centric. This cycle of drafting, testing, and refining not only reduces development risks but also fosters innovation by continuously challenging assumptions and improving on initial ideas.
            </p>
          </div>
        </div>

        <div className="blog-body space-y-4 text-foreground text-[1.125rem] leading-[1.625] [text-wrap:balance]">
          <p>
            When designing mobile interfaces, it's crucial to consider both the visual hierarchy and the functional organization of components. The examples below demonstrate different approaches to structuring mobile interfaces while maintaining consistency in the design system.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="w-full">
            <img
              src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Untitled-2024-11-02-1609-SQoDxRYkbVcXazvDP5MOrHCJnLex4W.png"
              alt="Mobile interface mockup showing Finance Checker and File Exporter status list"
              className="w-full h-auto"
            />
          </div>
          <div className="w-full">
            <img
              src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Untitled-2024-11-02-1609-SQoDxRYkbVcXazvDP5MOrHCJnLex4W.png"
              alt="Mobile interface mockup showing Finance Checker and File Exporter status list"
              className="w-full h-auto"
            />
          </div>
        </div>

        <p className="mt-8 text-foreground text-lg leading-relaxed">
          Developing personality through visual language is important because it establishes a unique and memorable identity that resonates with users on an emotional level. Visual elements such as color, typography, shapes, and imagery work together to communicate values, tone, and intent, transforming functional designs into meaningful experiences. A strong visual personality helps differentiate a product in a crowded market, creating a sense of authenticity and trust. It also reinforces brand recognition and fosters user connection, making the design more relatable and impactful. By thoughtfully crafting a visual language, designers can ensure that the personality of the product aligns seamlessly with its purpose and audience.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8">
          <div className="w-full h-[600px] relative">
            <img
              src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Tsibel%20v0%20Nov%202%202024-oj65VwBsxqVn1tvuvkslFWzkieUCXk.png"
              alt="Mobile interface mockup of AI Agents with Finance Checker and File Exporter status list"
              className="w-full h-full object-contain"
            />
          </div>
          <div className="w-full h-[600px] relative">
            <img
              src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Untitled-2024-11-02-1609-vjVLPn2PoYPJAQCPFQQgE3DSHBVUZf.png"
              alt="Alternative view of mobile interface showing AI Agents status indicators"
              className="w-full h-full object-contain"
            />
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default ThoughtMobileMocks 